import { render, staticRenderFns } from "./mncp.vue?vue&type=template&id=55072f65&scoped=true"
import script from "./mncp.vue?vue&type=script&lang=js"
export * from "./mncp.vue?vue&type=script&lang=js"
import style0 from "./mncp.vue?vue&type=style&index=0&id=55072f65&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55072f65",
  null
  
)

export default component.exports